import React from 'react'
import PropTypes from 'prop-types'
import FieldForProp from '../../../../common/FieldForProp'
import { Button } from '../../../../common/functionalComponents'

export const MemberFormComponent = ({
  properties,
  withInfo,
  formData,
  loading,
  actions: { handleValueChange, handleUserUpdate, handleSubmit },
}) => (
  <div className="body">
    <div className="content">
      <div className="page-header">
        <h2 className="page-header__title">My Profile</h2>
      </div>
      <div className="page-body member-form__content">
        <div>
          <p className="member-form__explanation">* Required Information</p>
          {properties.map((prop) => (
            <fieldset key={prop.key} className="tenants-edit-form__field">
              <FieldForProp
                prop={prop}
                withInfo={withInfo}
                value={formData[prop.key]}
                onValueChange={(value) => handleValueChange(value, prop.key)}
                controlled={true}
                disabled={[
                  'daimlerId',
                  'firstName',
                  'lastName',
                  'email',
                ].includes(prop.key)}
              />
            </fieldset>
          ))}
          <div className="tenants-edit-form__main-button">
            <Button
              disabled={loading}
              variant="secondary"
              size="small"
              onClick={handleUserUpdate}
            >
              Update my profile from Alice
            </Button>
            <Button
              disabled={loading}
              variant="primary"
              size="small"
              className="wb-margin-start-xs"
              onClick={handleSubmit}
            >
              Save
            </Button>
          </div>
        </div>
      </div>
    </div>
  </div>
)

MemberFormComponent.propTypes = {
  properties: PropTypes.arrayOf(PropTypes.shape({ key: PropTypes.string })),
  withInfo: PropTypes.bool,
  formData: PropTypes.object,
  loading: PropTypes.bool,
  actions: PropTypes.shape({
    handleValueChange: PropTypes.func,
    handleUserUpdate: PropTypes.func,
    handleSubmit: PropTypes.func,
  }),
}
